import Vue from "vue";
import Cookies from "js-cookie";

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "@/assets/styles/common.css";
import "@/assets/styles/index.scss"; // custome global css

import App from "./App.vue";
// 路由配置
import router from "./router/index";
// 状态管理 store 配置
import store from "./store/index";
import mixins from "@/mixins";
// 全局定义echarts
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";

import GLOBAL from "./utils/global";

Vue.component("v-chart", ECharts);

import anjiSelect from "@/components/AnjiPlus/anji-select";
Vue.component("anji-select", anjiSelect);

// permission control
// import "@/permission";

import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";
Vue.use(Avue);

Vue.use(Element, {
  zhLocale,
  size: Cookies.get("size") || "medium", // set element-ui default size
});
Vue.mixin(mixins);

Vue.prototype.$pageSizeAll = [10, 50, 100, 200, 500];
Vue.prototype.$global = GLOBAL;

Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
